import * as React from 'react'
import styled from '@emotion/styled'
import { colors, fontFamilies } from '@configs/styles/config'
import { useTranslation } from 'react-i18next'

const InfoSection: React.FC = () => {
  const { t } = useTranslation('about')

  return (
    <SectionWrapper>
      <Container>
        <VisionLabel>{t('info.visionLabel')}</VisionLabel>
        <Row>
          <LeftCol>
            <div>
              <SectionTitle>{t('info.problem.title')}</SectionTitle>
              <SectionText>{t('info.problem.description')}</SectionText>
            </div>
          </LeftCol>
        </Row>
        <Divider />
        <Row>
          <LeftCol>
            <div>
              <SectionTitle>{t('info.solution.title')}</SectionTitle>
              <SectionText>{t('info.solution.description')}</SectionText>
            </div>
          </LeftCol>
          <RightCol>
            <div>{t('info.solution.principles.structured')}</div>
            <div>{t('info.solution.principles.quality')}</div>
            <div>{t('info.solution.principles.pacing')}</div>
            <div>{t('info.solution.principles.focus')}</div>
          </RightCol>
        </Row>
      </Container>
    </SectionWrapper>
  )
}

export default InfoSection

const SectionWrapper = styled.section`
  width: 100%;
  background: ${colors.uguWhite};
  color: #222;
  padding: 2rem 1rem 3rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Container = styled.div`
  width: 100%;
  max-width: calc(1334px);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 5rem 1rem 1rem 1rem;
  min-height: 100%;
  display: flex;
  /* @media (min-width: 640px) {
    padding: 5rem 2rem;
  }
  @media (min-width: 769px) {
    padding: 5rem 2rem;
  }
  @media (min-width: 1024px) {
    padding: 5rem 0;
    margin: auto;
    max-width: 474px;
  }
  @media (min-width: 1324px) {
    padding: 0rem 0;
    margin: auto;
    max-width: 439px;
  } */
`

const VisionLabel = styled.div`
  font-size: 1rem;
  color: #444;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  /* margin-bottom: 2rem; */
  font-family: ${fontFamilies.medium};
  @media (max-width: 640px) {
    margin-bottom: -1.5rem;
  }
`

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  align-items: flex-start;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`

const RightCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 1.5rem;
  font-family: ${fontFamilies.semiBold};
`

const SectionTitle = styled.h2`
  font-size: 2.7rem;
  font-weight: 700;
  margin-bottom: 0.7rem;
  font-family: ${fontFamilies.semiBold};
`

const SectionText = styled.p`
  font-size: 1.15rem;
  color: #222;
  margin-bottom: 0.5rem;
  font-family: ${fontFamilies.regular};
`

const Divider = styled.hr`
  border: none;
  border-top: 2px solid #222;
  margin: 1rem 0;
  width: 100%;
  opacity: 0.18;
`
